import React, { useEffect, useState } from 'react';
import Receivable from './Receivable';
import Payable from './Payable';
import Vendors from './Vendors';
import { useGetApproval } from '../../../../../hooks/queries-and-mutations/settings';
import { useAppSelector } from '../../../../../store/hooks';
import { selectBusiness } from '../../../../../selectors/business-selector';
import { groupDataByLevel } from '../../../../../utils';

export default function Approval() {
  const { docs } = useAppSelector(selectBusiness);
  const { data: approvals, refetch } = useGetApproval({
    businessId: docs[0]?.businessID?._id,
  });
  const groupedData = groupDataByLevel(approvals?.docs ?? []);
  const [groupedState, setGroupedState] = useState<any>(
    groupDataByLevel(approvals?.docs ?? [])
  );

  useEffect(() => {
    setGroupedState(groupDataByLevel(approvals?.docs ?? []));
  }, [approvals?.docs]);

  return (
    <div className="w-full overflow-auto">
      <div className="border-b min-[580px]:px-9 max-[580px]:px-4 py-5">
        <p className="font-semibold text-2xl font-inter text-black">Approval</p>
      </div>
      <div className="py-8 min-[580px]:px-8 max-[590px]:p-4 space-y-7 mb-52">
        <Receivable
          businessId={docs[0]?.businessID?._id}
          receivable={groupedData.receivable}
          groupedState={groupedState.receivable}
          refetch={() => refetch()}
        />
        <Payable
          businessId={docs[0]?.businessID?._id}
          payable={groupedData.payable}
          refetch={() => refetch()}
          groupedState={groupedState.payable}
        />
        <Vendors
          businessId={docs[0]?.businessID?._id}
          vendor={groupedData.vendor}
          refetch={() => refetch()}
          groupedState={groupedState.vendor}
        />
      </div>
    </div>
  );
}
